import { useQuery } from '@tanstack/react-query';
import { GetLinkTypes } from '../api/links.js';
import { useState, useEffect } from 'react';

export const useLinkTypes = () => {
  const THREE_HOURS = 3 * 60 * 60 * 1000;
  const [LINKTYPE, setLINKTYPE] = useState({});
  const linkTypeQuery = useQuery({
    queryKey: ['GetLinkTypes'],
    queryFn: () => GetLinkTypes()(),
    staleTime: THREE_HOURS,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  useEffect(() => {
    if (linkTypeQuery.data) {
      const mapped = linkTypeQuery.data.reduce((acc, t) => {
        acc[t.name.toUpperCase()] = t.id;
        return acc;
      }, {});
      setLINKTYPE(mapped);
    }
  }, [linkTypeQuery.data]);

  return {
    LINKTYPE,
    data: linkTypeQuery.data,
    isLoading: linkTypeQuery.isLoading || linkTypeQuery.isFetching,
    isError: linkTypeQuery.isError,
  };
};
